import { Badge } from "@/components/ui/badge";

const MAP = {
  approved: { label: "Aprovado", bg: "#E1EDE4", text: "#2C543B" },
  changes_requested: { label: "Alterações", bg: "#FDF3E1", text: "#805B10" },
  rejected: { label: "Não Aprovado", bg: "#FBE6E4", text: "#8A2A22" },
  pending: { label: "Pendente", bg: "#EAE3DB", text: "#5C4A43" },
  scheduled: { label: "Agendado", bg: "#E3EDF5", text: "#1E4A75" },
  published: { label: "Já publicado", bg: "#1E5A2C", text: "#F9F6F0" },
};

export default function StatusBadge({ status, className = "" }) {
  const cfg = MAP[status] || MAP.pending;
  return (
    <Badge
      className={`rounded-full px-3 py-1 text-xs font-medium border-0 hover:opacity-90 ${className}`}
      style={{ background: cfg.bg, color: cfg.text }}
      data-testid={`status-badge-${status}`}
    >
      {cfg.label}
    </Badge>
  );
}
